import {
  TOGGLE_SIDE_DRAWER,
  OAUTH_SHOW_AUTH_WINDOW,
  SET_APPBAR_TITLE,
  SET_LANGUAGE,
  SET_DRAWER_TEXT_WIDTH,
  SET_DRAWER_WIDTH,
} from "../../actions/ui";
import { buildtranslatetObject } from "../../utils/translator";

export const initialState = {
  sideDrawerOpen: true,
  showOAuthWindow: false,
  title: "home",
  translate: buildtranslatetObject(navigator.language || navigator.userLanguage),
  language: navigator.language,
  sideDrawerTextWidth: 0,
  sideDrawerWidth: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_SIDE_DRAWER:
      return {
        ...state,
        sideDrawerOpen: action.sideDrawerOpen,
      };
    case OAUTH_SHOW_AUTH_WINDOW:
      return {
        ...state,
        showOAuthWindow: action.showOAuthWindow,
      };
    case SET_APPBAR_TITLE: {
      return {
        ...state,
        title: action.title,
      };
    }
    case SET_LANGUAGE:
      return {
        ...state,
        translate: buildtranslatetObject(action.language),
        language: action.language,
        sideDrawerTextWidth: 0,
      };
    case SET_DRAWER_TEXT_WIDTH:
      return {
        ...state,
        sideDrawerTextWidth: action.width,
      };
    case SET_DRAWER_WIDTH:
      return {
        ...state,
        sideDrawerWidth: action.width,
      };
    default:
      return state;
  }
};
